<script setup>
import { toLocalUrl } from '@/utils/helpers';
defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data.background_color}` : '',
      data?.spacing?.top ? `section--top-${data.spacing.top}` : '',
      data?.spacing?.bottom ? `section--bottom-${data.spacing.bottom}` : '',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div class="certificate">
        <NuxtImg
          v-if="data?.icon?.src"
          class="certificate__icon"
          :src="data?.icon?.src"
          :alt="data?.icon?.alt"
          :height="data?.icon?.height"
          :width="data?.icon?.width"
          data-aos="zoom-in"
          data-aos-easing="ease-out-quad"
          loading="lazy"
        />
        <p
          :class="[
            'certificate__title accent',
            data?.background_color === 'black' ? 'white' : '',
          ]"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data?.title"
        ></p>
        <Button
          v-if="data?.file"
          v-slot="slotProps"
          as-child
          variant="text"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
        >
          <CTagDetect
            target="_blank"
            :to="toLocalUrl(data?.file)"
            :class="[
              slotProps.class,
              'button-icon-prev',
              data?.background_color === 'black' ? 'white' : 'black',
            ]"
            class="certificate__button link-normal js-button-certificate"
          >
            <CIcon
              class="button-icon-prev-icon"
              :name="
                data?.background_color === 'black'
                  ? 'download'
                  : 'download-black'
              "
              width="16"
              height="16"
            />
            {{ $t('ukravto_group.download_certificate') }}
          </CTagDetect>
        </Button>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.certificate {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin: 0 auto;
  text-align: center;
  @include media-breakpoint-up(sm) {
    max-width: 50%;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 24);
  }
  &__title {
    margin: 0;
  }
  &__button {
    width: fit-content;
  }
}
</style>
